import { useField } from 'formik';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
	// lightBackground: {
	// 	height: '2.5rem',
	// 	fontSize: '1rem',
	// 	border: `1px solid ${theme.palette.divider}`
	// },
	inputStyle: {
		color: 'inherit',
		'&.small': {
			fontSize: '0.8rem',
		},
		'&.large': {
			height: '2.8rem',
		},
	},
	errorStyle: {
		color: theme.palette.error.main,
	},
	iconLeftStyle: {
		color: '#888 !important',
		'&.large': {
			fontSize: '1.2rem',
		},
	},
}));

const TextInputField = ({
	label,
	lightBackground,
	onChangeCallBack,
	iconLeft,
	className,
	help,
	...props
}) => {
	const classes = useStyles();
	const [field, meta] = useField(props);

	const handleOnChangeCallBack = (event) => {
		const value_ = event.target.value;
		onChangeCallBack && onChangeCallBack(value_);
	};

	// useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
	// which we can spread on <input> and alse replace ErrorMessage entirely.
	const { id, name, size } = props;
	return (
		<div className={`control ${iconLeft && 'has-icons-left'} ${className}`}>
			{label && <label htmlFor={id || name}>{label}</label>}
			{onChangeCallBack && (
				<input
					className={`${
						classes.inputStyle
					} input ${size} input-textfield ${lightBackground && classes.lightBackground}`}
					{...field}
					{...props}
					// value={value}
					onChange={handleOnChangeCallBack}
				/>
			)}
			{!onChangeCallBack && (
				<input
					className={`${
						classes.inputStyle
					} input ${size} input-textfield ${lightBackground && classes.lightBackground}`}
					{...field}
					{...props}
				/>
			)}
			{iconLeft && (
				<span className={`icon ${size} is-left ${classes.iconLeftStyle}`}>
					<i className={`fa ${iconLeft}`} />
				</span>
			)}

			{meta.touched && meta.error ? (
				<div className={classes.errorStyle}>{meta.error}</div>
			) : null}
			{help && <p className="help">{help}</p>}
		</div>
	);
};

TextInputField.propTypes = {
	label: PropTypes.string,
	help: PropTypes.string,
	id: PropTypes.string,
	size: PropTypes.string,
	name: PropTypes.string,
	lightBackground: PropTypes.bool,
	iconLeft: PropTypes.string,
	onChangeCallBack: PropTypes.func,
	className: PropTypes.string,
};

export default TextInputField;
